export const GUEST_USER_LOGIN_REQUEST = 'GUEST_USER_LOGIN_REQUEST'
export const GUEST_USER_LOGIN_RESET = 'GUEST_USER_LOGIN_RESET'
export const GUEST_USER_LOGIN_FAIL = 'GUEST_USER_LOGIN_FAIL'
export const GUEST_USER_LOGIN_SUCCESS = 'GUEST_USER_LOGIN_SUCCESS'

export const GUEST_USER_DETAIL_REQUEST = 'GUEST_USER_DETAIL_REQUEST'
export const GUEST_USER_DETAIL_RESET = 'GUEST_USER_DETAIL_RESET'
export const GUEST_USER_DETAIL_FAIL = 'GUEST_USER_DETAIL_FAIL'
export const GUEST_USER_DETAIL_SUCCESS = 'GUEST_USER_DETAIL_SUCCESS'

export const GUEST_USER_COMMENT_INSERT_REQUEST = 'GUEST_USER_COMMENT_INSERT_REQUEST'
export const GUEST_USER_COMMENT_INSERT_RESET = 'GUEST_USER_COMMENT_INSERT_RESET'
export const GUEST_USER_COMMENT_INSERT_FAIL = 'GUEST_USER_COMMENT_INSERT_FAIL'
export const GUEST_USER_COMMENT_INSERT_SUCCESS = 'GUEST_USER_COMMENT_INSERT_SUCCESS'

export const GUEST_COMMENT_TODAY_REQUEST = 'GUEST_COMMENT_TODAY_REQUEST'
export const GUEST_COMMENT_TODAY_SUCCESS = 'GUEST_COMMENT_TODAY_SUCCESS'
export const GUEST_COMMENT_TODAY_FAIL = 'GUEST_COMMENT_TODAY_FAIL'
export const GUEST_COMMENT_TODAY_RESET = 'GUEST_COMMENT_TODAY_RESET'

export const GUEST_COMMENT_PAST_REQUEST = 'GUEST_COMMENT_PAST_REQUEST'
export const GUEST_COMMENT_PAST_SUCCESS = 'GUEST_COMMENT_PAST_SUCCESS'
export const GUEST_COMMENT_PAST_FAIL = 'GUEST_COMMENT_PAST_FAIL'
export const GUEST_COMMENT_PAST_RESET = 'GUEST_COMMENT_PAST_RESET'

export const ALL_GUEST_COMMENT_RECENT_REQUEST = 'ALL_GUEST_COMMENT_RECENT_REQUEST'
export const ALL_GUEST_COMMENT_RECENT_SUCCESS = 'ALL_GUEST_COMMENT_RECENT_SUCCESS'
export const ALL_GUEST_COMMENT_RECENT_FAIL = 'ALL_GUEST_COMMENT_RECENT_FAIL'
export const ALL_GUEST_COMMENT_RECENT_RESET = 'ALL_GUEST_COMMENT_RECENT_RESET'

